/* ============================================================
   Offe Market - put the % off star over the product image

   The Badges block renders inside the product page's info
   column. On desktop that column is position: sticky, which
   makes it the containing block for anything absolutely
   positioned inside it - so the star landed over the product
   title instead of over the image. (It looked right on narrow
   screens only because the column isn't sticky there.)

   Moving the badge row into the gallery's own positioned
   wrapper - .product__media-list-wrapper, the same box the
   gallery caption is pinned to - puts it over the image at
   every breakpoint, with no width maths and nothing to keep in
   sync. Positioning lives in assets/custom.css, section 1.

   Quick view is untouched: it renders a separate copy
   (.product__badges-qv) into a modal that has no sticky column,
   and that copy is already in the right place.
   ============================================================ */

(function () {
  function place() {
    var outers = document.querySelectorAll('.product__outer');

    for (var i = 0; i < outers.length; i++) {
      var outer = outers[i];
      var badges = outer.querySelector('.product__badges');
      if (!badges) continue;

      var host =
        outer.querySelector('.product__media-list-wrapper') ||
        outer.querySelector('.product__media');
      if (!host) continue;

      if (badges.parentElement !== host) host.appendChild(badges);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }

  // theme editor re-renders a section without a full page load
  document.addEventListener('shopify:section:load', place);
})();
